import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, Tag, ChevronRight } from 'lucide-react';
import api from '../../utils/api';
import { cldImg } from '../../utils/cloudinary';

export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/blogs').then(({ data }) => setBlogs(data.blogs || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-16"><div className="w-8 h-8 border-4 border-brand-yellow border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 pb-24 md:pb-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-brand-dark">Blog</h1>
        <p className="text-gray-500 mt-1">Tips, guides & updates from TheYellove</p>
      </div>

      {blogs.length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <p className="text-lg">No posts yet. Check back soon!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map(blog => (
            <Link key={blog.id} to={`/blog/${blog.slug}`}
              className="group bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5">
              {blog.featured_image ? (
                <div className="aspect-video overflow-hidden">
                  <img src={cldImg(blog.featured_image, 600)} alt={blog.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
              ) : (
                <div className="aspect-video bg-gradient-to-br from-brand-yellow-light to-brand-cream flex items-center justify-center text-4xl">📝</div>
              )}
              <div className="p-5">
                {blog.category && (
                  <span className="text-xs font-bold text-brand-yellow uppercase tracking-wide">{blog.category}</span>
                )}
                <h2 className="text-base font-bold text-brand-dark mt-1 mb-2 line-clamp-2 group-hover:text-brand-yellow transition-colors">{blog.title}</h2>
                {blog.excerpt && <p className="text-sm text-gray-500 line-clamp-2 mb-4">{blog.excerpt}</p>}
                <div className="flex items-center justify-between text-xs text-gray-400">
                  <div className="flex items-center gap-3">
                    {blog.author && <span className="flex items-center gap-1"><User className="w-3 h-3" />{blog.author}</span>}
                    <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{new Date(blog.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                  </div>
                  <ChevronRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
